import React, { useContext, useEffect } from "react";
import AllRoutes from "./AllRouters/Index";
import { Toaster } from "react-hot-toast";
import ScrollToTop from "./hooks/ScrollToTop";
import { MyContext } from "./hooks/MyContextProvider";
import { versionManager } from "./utils/versionManager";

function App() {
  const { selectedLocation, user, updateSelectedLocation } =
    useContext(MyContext);

  useEffect(() => {
    // Check for app updates on component mount
    versionManager.checkForUpdates();

    // Set up periodic version checks (every 5 minutes)
    const versionCheckInterval = setInterval(() => {
      versionManager.checkForUpdates();
    }, 5 * 60 * 1000);

    return () => {
      clearInterval(versionCheckInterval);
    };
  }, []);

  useEffect(() => {
    if (!selectedLocation?.locationid && user?.role === "admin") {
      updateSelectedLocation({
        locationid: 1,
        name: "Vadodara",
      });
    }
  }, [selectedLocation, user]);

  return (
    <>
      <ScrollToTop />
      <AllRoutes />
      <Toaster position="top-right" reverseOrder={false} />
    </>
  );
}

export default App;
